// extracted by mini-css-extract-plugin
export default {"overview":"assessment-details_overview__jTyho","completionParticipants":"assessment-details_completionParticipants__jinOG"};